export default {
  trackingQuery: {
    title: '运踪查询',
    subtitle: '输入提单号和船公司，快速查询货物实时轨迹',
    billNo: '提单号',
    billNoPlaceholder: '请输入提单号',
    billNoRequired: '请输入提单号',
    carrier: '船公司',
    carrierPlaceholder: '请输入或选择船公司',
    selectCarrier: '请选择船公司',
    carrierRequired: '请输入船公司',
    mapTitle: '运踪地图',
    mapPlaceholder: '请输入提单号和船公司进行查询',
    mapLoading: '正在加载轨迹地图...',
    querySuccess: '查询成功',
    queryFailed: '查询失败，请稍后重试',
    modal: {
      loginTitle: '需要登录',
      loginMessage: '使用运踪查询功能需要先登录账号，请登录后重试',
      goToLogin: '前往登录',
      certifyTitle: '需要企业认证',
      certifyMessage: '使用运踪查询功能需要完成企业认证，请先完成企业认证',
      goCertify: '前往认证',
      understood: '知道了',
      goToAppCenter: '前往应用中心',
      pendingTitle: '申请审核中',
      pendingMessage: '您的运踪查询应用申请正在审核中，审核通过后即可使用该功能',
      rejectedTitle: '申请未通过',
      rejectedMessage: '您的运踪查询应用申请未通过审核，请前往应用中心查看详情并重新申请',
      disabledTitle: '应用已禁用',
      disabledMessage: '运踪查询应用已被禁用，如有疑问请联系管理员',
      notActivatedTitle: '需要开通应用',
      notActivatedMessage: '使用运踪查询功能需要先开通应用，请前往应用中心申请开通',
    }
  }
}